import { createPromotionsModel } from './PromotionsModel';

// eslint-disable-next-line no-duplicate-imports
export { SOCKET_ID } from './PromotionsModel';

export const promotionsModel = createPromotionsModel();
